import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';

window.$ = window.jQuery = require('jquery');
const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  );
};

if (process.env.REACT_APP_ENV !== "production") {
  import("@axe-core/react").then((axe) => {
    axe.default(React, ReactDOM, 1000);
    renderApp();
  });
} else {
  renderApp();
}
